import React from "react";
import { StarIcon } from "lucide-react";
import { SectionCTA } from "./SectionCTA";
import { testimonials } from "../data/content";
function Stars() {
  return <div className="flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-320" data-mp="3ksqfx8edni7j">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-gold-400 text-gold-400" aria-hidden="true" data-id="element-321" data-mp="3b0uepogzvbz3" data-mpi={i} />)}
    </div>;
}
export function Testimonials() {
  const [featured, ...rest] = testimonials;
  return <section className="bg-brand-50 px-5 py-16 md:px-8 md:py-24" data-id="element-322" data-mp="31zd3ajej7ygq">
      <div className="mx-auto max-w-6xl" data-id="element-323" data-mp="32290u6mgwl4n">
        <h2 className="text-center text-3xl font-extrabold leading-tight tracking-tight text-brand-900 md:text-[2.6rem]" data-id="element-324" data-mp="2x005x4q1b8zw">
          What healthcare professionals are saying
        </h2>
        <div className="mt-4 flex items-center justify-center gap-2 text-base font-semibold text-ink" data-id="element-325" data-mp="v9yghcqvjxas">
          <Stars data-id="element-326" data-mp="q9u0roxsj6lm" />
          <span data-id="element-327" data-mp="qbeu5b8dcjhw">4.9/5 from clinicians who use the roadmap</span>
        </div>

        <figure className="mt-12 grid items-center gap-6 rounded-3xl bg-brand-900 p-6 text-white md:grid-cols-[200px_1fr] md:gap-10 md:p-10" data-id="element-328" data-mp="h5ezbmd4bx17">
          <img src={featured.photo} alt={featured.name} className="h-24 w-24 rounded-2xl object-cover md:h-[200px] md:w-[200px]" data-id="element-329" data-mp="m6m55fvpam58" />
          <div data-id="element-330" data-mp="c7wnno7pv3pi">
            <Stars data-id="element-331" data-mp="c7dg91fozxpq" />
            <blockquote className="mt-4 text-xl font-semibold leading-relaxed md:text-2xl" data-id="element-332" data-mp="c8y2m3rusaci">“{featured.quote}”</blockquote>
            <figcaption className="mt-5" data-id="element-333" data-mp="14v9c63xftllg">
              <p className="font-extrabold" data-id="element-334" data-mp="14u7pf2727anw">{featured.name}</p>
              <p className="text-sm text-brand-200" data-id="element-335" data-mp="q6wgl829i4rh">{featured.role}</p>
            </figcaption>
          </div>
        </figure>

        <div className="mt-6 grid gap-6 md:grid-cols-2" data-id="element-336" data-mp="v4o6jwjcjgt1">
          {rest.map(t => <figure key={t.name} className="flex flex-col rounded-3xl bg-white p-6 md:p-8" data-id="element-337" data-mp="1iv1wnhidf5kz">
              <Stars data-id="element-338" data-mp="1nma8slb3551u" />
              <blockquote className="mt-4 text-base leading-relaxed text-ink" data-id="element-339" data-mp="1nmscg302uljs">“{t.quote}”</blockquote>
              <figcaption className="mt-auto flex items-center gap-4 pt-6" data-id="element-340" data-mp="1xgpnflj2x8ct">
                <img src={t.photo} alt={t.name} className="h-14 w-14 rounded-full object-cover" loading="lazy" data-id="element-341" data-mp="1sio3kydtx50a" />
                <div data-id="element-342" data-mp="1og9g20z7th2o">
                  <p className="font-bold text-ink" data-id="element-343" data-mp="1ofhnz04tu1h5">{t.name}</p>
                  <p className="text-sm text-muted" data-id="element-344" data-mp="1jj12kdp0i17r">{t.role}</p>
                </div>
              </figcaption>
            </figure>)}
        </div>

        <SectionCTA label="Get my perimenopause clinical roadmap" data-id="element-345" data-mp="1ekzjhsrl61wa" />
      </div>
    </section>;
}